import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router";
import Select, { SingleValue } from "react-select";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import MultiSelectList from "../questions/metadataDropDownList";
import { IBreadcrumb } from "../../../model/interface/breadcrumb";
import { IGrade, IState } from "../../../model/interface/domain";
import { IContent } from "../../../model/interface/content";
import { ISubjectPage } from "../../../model/interface/subject";
import Breadcrumb from "../../shared/common/breadcrumb";
import {
  deleteBundleProduct,
  getBundleById,
  postBundle,
  postBundleProduct,
  updateBundle,
} from "../../../api/bundle.service";
import Constant from "../../../utils/constant";
import {
  getGradeAll,
  getStateAll,
  getSubject,
} from "../../../api/subject.service";
import {
  AddIcon,
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  RemoveIcon,
} from "../../../assets/icons/index";
import { IBundleList, IBundleProduct } from "../../../model/interface/bundle";
import {
  IReactSelect,
  ISelectElement,
} from "../../../model/interface/keyValuePair";
import Loader from "../../shared/loader/loader";
import AccordionBundles from "../../shared/common/accordionBundles";
import constant from "../../../utils/constant";
import { ISellableProduct } from "../../../model/interface/sellableProduct";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiSelect from "../../shared/common/multiSelect";
import { useNumericParam } from "../../../utils/useNumericParam";

const ManageBundle = () => {
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];

  const defaultPageSize = 10;
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [grade, setGrade] = useState<IGrade[]>([]);
  const [state, setState] = useState<IState[]>([]);
  const [content, setContent] = useState<IContent[]>([]);
  const [subjects, setSubjects] = useState<ISubjectPage[]>([]);
  const [editBundleProduct, setEditBundleProduct] = useState<IBundleProduct[]>(
    []
  );
  const [selectSubjects, setSelectSubjects] = useState<number>(0);
  const [selectContent, setSelectContent] = useState<number>(0);
  const [selectState, setSelectState] = useState<number>(0);
  const [selectGrade, setSelectGrade] = useState<number>(0);
  const [selectGradeLevel, setSelectGradeLevel] = useState<ISelectElement>();
  const [bundleName, setBundleName] = useState<string>("");
  const [bundleProductId, setBundleProductId] = useState<number>();
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const navigate = useNavigate();
  const id = useNumericParam("id");
  const bundleId = useNumericParam("bundleId");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const bundleToEditId = id ? id.toString() : "";
  const [loading, setLoading] = useState<boolean>(false);
  const [sellableProducts, setSellableProducts] = useState<ISellableProduct[]>(
    []
  );
  const [sortDir, setSortDir] = useState<any>(true);
  const [orderByColumn, setOrderByColumn] = useState("name");
  const [products, setProducts] = useState<IBundleProduct[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [reload, setReload] = useState<boolean>(false);
  const [reloadProducts, setReloadProducts] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const location = useLocation();
  const parameters = location.state as any;
  const [selectedStates, setSelectedStates] = useState<Array<any>>([]);
  const [selectedSalesForceLevel, setSelectedSalesForceLevel] =
    useState<IReactSelect>();
  const [isAlaCarte, setIsAlaCarte] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);
  const salesForceLevel = [
    { label: "Elementary", value: 1 },
    { label: "Middle", value: 2 },
    { label: "High", value: 3 },
  ];
  const breadcrumbItems = () => {
    const items: Array<IBreadcrumb> = [
      { name: "Bundle", url: Constant.BUNDLES },
      { name: bundleToEditId ? "Edit Bundle" : "Add Bundle", url: "" },
    ];

    if (bundleToEditId) {
      items.push({ name: bundleToEditId, url: "" });
    }
    return items;
  };

  const bindData = (products: any[]) => {
    let sellableProducts: Array<ISellableProduct> = [];
    if (products.length > 0) {
      sellableProducts = products.map((product) => {
        return {
          sellableProductId: product.sellableProductId,
          sellableProductName: product.name,
          subjectId: 0,
        };
      });
      setSellableProducts(sellableProducts);
      setReloadProducts(!reloadProducts);
    }
  };

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setState(newStateData);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrade(newGradeData);
  };

  const getContent = async () => {
    const module = await import("../../../api/contentArea.service");
    const response = module.getContentArea(999, 1);
    const data = (await response).data;
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContent(newContentData);
  };

  const getSubjectData = async () => {
    const params = {
      name: "",
      contentAreaId: selectContent || 0,
      stateId: selectState || 0,
      gradeId: selectGrade || 0,
      gradeLevel: selectGradeLevel?.value || "",
      orderbyColumn: "name",
      sortDir: "asc",
      pageSize: 999,
      pageNumber: 1,
      isActive: true,
      isApproved: true,
    };

    const response = getSubject(params);
    const data = (await response).data;
    let newSubjectData = [];
    if (data.data.length > 0) {
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubjects(newSubjectData);
  };

  const handlebundleName = (e) => {
    setBundleName(e.target.value);
  };

  const handleBundleProduct = (e) => {
    setBundleProductId(parseInt(e.target.value));
  };

  const handleSaveBundle = () => {
    setErrorMessage(true);
    const newEditBundleProductIds = editBundleProduct?.map(
      (el) => el.sellableProductId
    );
    const bundleProductIds = newEditBundleProductIds?.toString();
    const bundleData = {
      bundleId: bundleToEditId ? bundleToEditId : 0,
      name: bundleName,
      productIds: bundleProductIds,
      userId: 1,
      salesforceId: selectedSalesForceLevel?.value,
      stateIds: selectedStates?.map((ds) => ds.value)?.toString(),
      isAlaCarte: isAlaCarte,
      isActive: isActive,
    };

    if (bundleName === "") {
      toast.warning("Bundle name cannot be blank");
    } else if (bundleToEditId !== undefined && bundleToEditId !== "") {
      setLoading(true);
      updateBundle(bundleData).then(() => {
        setLoading(false);
        toast.success("Bundle updated successfully");
        if (parameters?.subjectId && parameters?.fromSubject) {
          navigate(
            Constant.SUBJECTDETAIL.replace(":id", parameters?.subjectId),
            { state: { subjectType: 1 } }
          );
        } else if (bundleToEditId !== undefined) {
          navigate(Constant.EDITBUNDLES.replace(":id", bundleToEditId));
        } else {
          navigate(Constant.BUNDLES);
        }
      });
    } else {
      toast.success("Bundle saved successfully");
      postBundle(bundleData).then((bundle) => {
        setLoading(false);
        if (bundle.data) {
          navigate(
            Constant.EDITBUNDLES.replace(":id", bundle.data.toString()),
            { state: { subjectId: parameters?.subjectId, fromSubject: true } }
          );
        }
      });
    }
  };

  const resetClickHandler = () => {
    setProducts([]);
    setBundleProductId(0);
    setSelectSubjects(0);
    setSelectContent(0);
    setSelectState(0);
    setSelectGrade(0);
    setSelectGradeLevel({ value: "", label: "" });
    setResetDropdownFlag(!resetDropdownFlag);
  };

  const handleEditBundle = async (bundleId?) => {
    if (bundleToEditId !== undefined || bundleId) {
      setLoading(true);
      const response = getBundleById(bundleId ? bundleId : bundleToEditId);
      const data = (await response).data;
      setLoading(false);
      if (data.sellableProducts) {
        bindData(data.sellableProducts);
      }
      setBundleName(data?.name);
      const salesForeceLevelFilt = salesForceLevel.filter(
        (ds) => ds.value === data?.salesforceId
      );
      if (salesForeceLevelFilt.length) {
        setSelectedSalesForceLevel({
          label: salesForeceLevelFilt[0].label,
          value: salesForeceLevelFilt[0].value,
        });
      }

      if (data?.states?.length) {
        const states = data?.states?.map((ds) => ({
          label: ds.name,
          value: ds.stateId,
        }));
        setSelectedStates(states);
      }
      if (salesForeceLevelFilt.length)
        setSelectedSalesForceLevel({
          label: salesForeceLevelFilt[0].label,
          value: salesForeceLevelFilt[0].value,
        });
      setIsAlaCarte(data.isAlaCarte);
      setIsActive(data.isActive);
      setEditBundleProduct(data?.products);
    }
  };

  useEffect(() => {
    // getSubjectData();
    getGradeData();
    getStateData();
    getContent();
  }, [id]);

  useEffect(() => {
    handleEditBundle(id);
  }, [id, reload]);

  useEffect(() => {
    getSubjectData();
  }, [selectContent, selectState, selectGrade, selectGradeLevel]);

  useEffect(() => {
    if (isLoaded) {
      filterClickHandler();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      filterClickHandler();

      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "GradeLevel") {
      setSelectGradeLevel({
        value: updateObj.value || "",
        label: updateObj.label || "",
      });
    }
  };

  const redirectToSellableProductDetail = (productId: number) => {
    if (productId) {
      navigate(
        constant.MANAGESELLABLEPRODUCT.replace(":id", productId.toString())
      );
    }
  };

  const redirectToBundleDetail = (bundleId: number) => {
    if (bundleId) {
      navigate(constant.EDITBUNDLES.replace(":id", bundleId.toString()));
    }
  };

  const filterClickHandler = async (resetObj?, onFilter?, column?) => {
    setLoading(true);
    let productData: Array<IBundleProduct> = [];

    const filterObj = {
      name: "",
      subjectId: resetObj ? 0 : selectSubjects,
      contentAreaId: resetObj ? 0 : selectContent,
      stateId: resetObj ? 0 : selectState,
      gradeId: resetObj ? 0 : selectGrade,
      gradeLevelId: resetObj ? "" : selectGradeLevel?.value,
      sellableProductId: resetObj ? 0 : bundleProductId,
      isActive: true,
      isApproved: true,
      orderByColumn: orderByColumn,
      sortDir: sortDir ? "asc" : "desc",
      pageSize: onFilter ? defaultPageSize : pageSize,
      pageNumber: onFilter ? 1 : pageNumber,
      gradeLevel: "",
      SellableProductId: 0,
    };
    const module = await import("../../../api/pricing.services");
    const response = module.getSellableProductAll(filterObj);
    const data = (await response).data;

    if (data.data.length > 0) {
      productData = data.data.map((product) => {
        return {
          bundleId: bundleToEditId,
          sellableProductId: product.sellableProductId || 0,
          name: `${product.name}`,
          productTypeId: constant.PRODUCTTYPE.SELLABLEPRODUCT,
        };
      });
    }
    setProducts(productData);
    setTotalPages(
      Math.ceil(data.totalRecords / (resetObj ? defaultPageSize : pageSize))
    );
    setTotalRecords(data.totalRecords);
    if (resetObj) {
      paginationRef?.current?.onReset();
      pageSizeRef?.current?.onReset();
    }

    setLoading(false);
  };

  const handleRedirect = (product: IBundleProduct) => {
    redirectToSellableProductDetail(product.sellableProductId);
  };

  const handleSortBy = (column: string) => {
    setSortDir(!sortDir);
    setOrderByColumn(column);
  };

  useEffect(() => {
    if (isLoaded) {
      filterClickHandler();
    }
  }, [sortDir]);

  const handleAddBundleProduct = (product: any, type) => {
    setLoading(true);
    if (type === "add") {
      postBundleProduct(product.bundleId, product.sellableProductId.toString())
        .then(() => {
          setLoading(false);
          setReload(!reload);
          toast.success("Sellable product added successfully");
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    }
    if (type === "remove") {
      deleteBundleProduct(product.bundleId, product.sellableProductId)
        .then(() => {
          setLoading(false);
          setReload(!reload);
          toast.success("Sellable product removed successfully");
        })
        .catch(() => {
          toast.error("Something went wrong");
        });
    }
  };

  const handleSelectedSalesForceLevel = (
    option: SingleValue<IReactSelect> | null
  ) => {
    if (option) {
      setSelectedSalesForceLevel(option);
    }
  };

  return (
    <AllowedTo perform={Permissions.bundle_modify} no={() => <AccessDenied />}>
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-2">
              <h3 className="text-lg font-light text-gray-900">Bundle</h3>
            </div>
            <Breadcrumb items={breadcrumbItems()} />

            <div className="flex">
              <form className="w-2/5 mr-14">
                <div className="grid grid-cols-1 mt-2">
                  <div>
                    <label className="text-sm font-medium text-gray-700">
                      Bundle Name
                    </label>

                    <div>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        autoComplete="off"
                        value={bundleName}
                        onChange={handlebundleName}
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                      {bundleName === "" && errorMessage === true && (
                        <span className="text-red-700 inline-block pt-1 text-sm">
                          Bundle Name is required
                        </span>
                      )}
                    </div>

                    <div className="mt-5">
                      <label className="text-sm text-gray-700">
                        Salesforce Level
                      </label>
                      <div className="mt-1 text-sm">
                        <Select
                          placeholder=""
                          options={salesForceLevel}
                          value={selectedSalesForceLevel}
                          onChange={handleSelectedSalesForceLevel}
                        />
                      </div>
                    </div>

                    <div className="mt-5">
                      <label className="text-sm text-gray-700">State</label>
                      <div className="mt-1 text-sm">
                        <MultiSelect
                          options={state}
                          selectedItems={selectedStates}
                          setSelectedItems={setSelectedStates}
                        />
                      </div>
                    </div>

                    <div className="flex items-center mt-5">
                      <input
                        id="isApproved"
                        type="checkbox"
                        className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                        checked={isAlaCarte}
                        onChange={(e) => setIsAlaCarte(e.target.checked)}
                      />
                      <span>A La Carte</span>
                    </div>

                    <div className="flex items-center mt-2">
                      <input
                        id="isApproved"
                        type="checkbox"
                        className="focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                      />
                      <span>Is Active</span>
                    </div>
                  </div>
                </div>

                <div className="shadow py-6 border rounded-lg mt-4 px-6">
                  <div className="sm:col-span-2 mb-4">
                    {bundleToEditId !== "" && (
                      <AccordionBundles
                        bundles={[]}
                        sellableProducts={sellableProducts}
                        productRedirectAction={redirectToSellableProductDetail}
                        bundleRedirectAction={redirectToBundleDetail}
                      />
                    )}
                  </div>

                  <div className="pb-2 border-t mt-5 items-center">
                    <button
                      type="button"
                      onClick={handleSaveBundle}
                      className=" cursor-pointer inline-flex items-center px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      {bundleId ? "Update" : "Save"}
                    </button>

                    <Link to={constant.BUNDLES} className="ml-2">
                      <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </form>
              {bundleToEditId ? (
                <div className="border-b pb-6 w-3/5">
                  <div className="border-b pt-3 font-semibold">
                    Add sellable product
                  </div>
                  <div className="pt-3 grid grid-cols-12 gap-6">
                    <div className="col-span-3 sm:col-span-3">
                      <label className="text-sm text-gray-700">
                        Sellable Product Id
                      </label>
                      <div className="contentArea">
                        <input
                          id="Product"
                          name="Product"
                          type="number"
                          autoComplete="off"
                          value={bundleProductId || ""}
                          onChange={handleBundleProduct}
                          className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                        />
                      </div>
                    </div>
                    <div className="col-span-3">
                      <label className="text-sm text-gray-700">
                        Content Area
                      </label>
                      <div className="mt-1 text-sm">
                        <MultiSelectList
                          dropValue={content}
                          defaultValue={"Content Area"}
                          value={selectContent}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setSelectContent}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-3">
                      <label className="text-sm text-gray-700">State</label>
                      <div className="mt-1 text-sm">
                        <MultiSelectList
                          dropValue={state}
                          defaultValue={"State"}
                          value={selectState}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setSelectState}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-3">
                      <label className="text-sm text-gray-700">Grade</label>
                      <div className="mt-1 text-sm">
                        <MultiSelectList
                          dropValue={grade}
                          defaultValue={"Grade"}
                          value={selectGrade}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setSelectGrade}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-3">
                      <label className="text-sm text-gray-700">
                        Grade Level
                      </label>
                      <div className="mt-1 text-sm">
                        <Select
                          className="mt-1 text-sm"
                          value={{
                            label: selectGradeLevel?.label,
                            value: selectGradeLevel?.value,
                          }}
                          onChange={(result) =>
                            updateDropdownValues({
                              ...result,
                              type: "GradeLevel",
                            })
                          }
                          options={gradeLevelData}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#B3B3B3",
                              primary: "#041E42",
                            },
                          })}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              background:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#1A1C23"
                                  : "white",
                              borderColor:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6B7280"
                                  : "#D1D5DB",
                              borderWidth: "1px",
                              "&:hover": {
                                borderColor:
                                  state.isFocused &&
                                  document.getElementsByClassName("dark")
                                    ?.length > 0
                                    ? "#6b7280"
                                    : state.isFocused
                                    ? "#4c5563"
                                    : "",
                              },
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "#374051",
                            }),
                            input: (base) => ({
                              ...base,
                              color:
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "white"
                                  : "",
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-span-3">
                      <label className="text-sm text-gray-700">Subject</label>
                      <div className="mt-1 text-sm">
                        <MultiSelectList
                          dropValue={subjects}
                          defaultValue={"Subject"}
                          value={selectSubjects}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setSelectSubjects}
                          multiple={false}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-start mt-8 items-center border-t ">
                    <button
                      className="inline-flex mr-3 items-center px-3 py-2 my-3 hover:bg-secondary-color border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                      type="button"
                      onClick={() => filterClickHandler(false, true)}
                    >
                      <FilterIcon className="w-3 h-3"></FilterIcon>
                      <span className="ml-2">Filter</span>
                    </button>

                    <button
                      type="button"
                      onClick={resetClickHandler}
                      className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                    >
                      <ResetIcon className="w-3 h-3"></ResetIcon>
                      <span className="ml-2">Reset Filter</span>
                    </button>
                  </div>
                  <div id="dataContainer" className="mt-4">
                    <div className="flex flex-col mt-1">
                      <div className="-my-2 sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="shadow border-b border-gray-200 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-primary-color">
                                <tr>
                                  <th
                                    scope="col"
                                    className="inline-flex items-center gap-2 px-6 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                                  >
                                    <span className="flex gap-2">
                                      Id
                                      <span className="cursor-pointer">
                                        {sortDir &&
                                        orderByColumn ===
                                          `sellableProductId` ? (
                                          <CaretUpSolidIcon
                                            onClick={() =>
                                              handleSortBy("sellableProductId")
                                            }
                                            className="w-5 h-5"
                                          ></CaretUpSolidIcon>
                                        ) : (
                                          <CaretDownSolidIcon
                                            onClick={() =>
                                              handleSortBy("sellableProductId")
                                            }
                                            className="w-5 h-5"
                                          ></CaretDownSolidIcon>
                                        )}
                                      </span>
                                    </span>
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                                  >
                                    <span className="flex gap-2">
                                      Name
                                      <span className="cursor-pointer">
                                        {!sortDir &&
                                        orderByColumn === "name" ? (
                                          <CaretUpSolidIcon
                                            onClick={() => handleSortBy("name")}
                                            className="w-5 h-5"
                                          ></CaretUpSolidIcon>
                                        ) : (
                                          <CaretDownSolidIcon
                                            onClick={() => handleSortBy("name")}
                                            className="w-5 h-5"
                                          ></CaretDownSolidIcon>
                                        )}
                                      </span>
                                    </span>
                                  </th>

                                  <th
                                    scope="col"
                                    className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {products &&
                                  products.map((product, index) => (
                                    <tr
                                      key={index}
                                      className={
                                        index % 2 === 0
                                          ? "bg-white"
                                          : "bg-gray-100"
                                      }
                                    >
                                      <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                        <div className="flex">
                                          <a
                                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                            onClick={() =>
                                              handleRedirect(product)
                                            }
                                            href={Constant.MANAGESELLABLEPRODUCT.replace(
                                              ":id",
                                              product.sellableProductId.toString()
                                            )}
                                          >
                                            {product.sellableProductId}
                                          </a>
                                        </div>
                                      </td>
                                      <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                        <a
                                          className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                          href={Constant.MANAGESELLABLEPRODUCT.replace(
                                            ":id",
                                            product.sellableProductId.toString()
                                          )}
                                        >
                                          {product.name}
                                        </a>
                                      </td>

                                      <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                        <div className="flex gap-3 justify-center">
                                          {sellableProducts !== null &&
                                            !sellableProducts
                                              .map((ds) => ds.sellableProductId)
                                              .includes(
                                                product.sellableProductId
                                              ) && (
                                              <AddIcon
                                                onClick={() =>
                                                  handleAddBundleProduct(
                                                    product,
                                                    "add"
                                                  )
                                                }
                                                className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                              />
                                            )}

                                          {sellableProducts !== null &&
                                            sellableProducts
                                              .map((ds) => ds.sellableProductId)
                                              .includes(
                                                product.sellableProductId
                                              ) && (
                                              <RemoveIcon
                                                onClick={() =>
                                                  handleAddBundleProduct(
                                                    product,
                                                    "remove"
                                                  )
                                                }
                                                className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                              />
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            <div className="flex justify-between items-center">
                              {products !== null && products.length !== 0 ? (
                                <>
                                  <Pagination
                                    pages={totalPages}
                                    setPageNumber={setPageNumber}
                                    ref={paginationRef}
                                  />
                                  <span>
                                    <span className="text-sm pr-4 ml-auto text-left-700">
                                      Showing {pageNumber} to{" "}
                                      {totalRecords < pageSize
                                        ? totalRecords
                                        : pageSize}{" "}
                                      of {totalRecords} results
                                    </span>

                                    <SelectPageSize
                                      setPageSize={setPageSize}
                                      type={"second"}
                                      ref={pageSizeRef}
                                    />
                                  </span>
                                </>
                              ) : (
                                <p className="p-2">No Records Found</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManageBundle);
